import {
  IItemTag,
  IItemTagData,
  ITag,
  ITagData,
  ITagFieldError,
  ITagFieldErrorData
} from './item-tag.types';

export class Tag implements ITag {
  readonly id?: number;

  readonly name: string;

  constructor(data: ITagData) {
    if (data.id) {
      this.id = data.id;
    }
    this.name = data.name ?? '';
  }

  validate(): boolean {
    throw new Error('Method not implemented.');
  }

  toString(): string {
    return this.name;
  }
}
export class ItemTag implements IItemTag {
  readonly id?: number;

  readonly tag: ITag | number;

  constructor(data: IItemTagData) {
    if (data.id) {
      this.id = data.id;
    }

    this.tag = typeof data.tag === 'number' ? data.tag : new Tag(data.tag);
  }

  validate(): boolean {
    throw new Error('Method not implemented.');
  }

  toString(): string {
    return this.tag.toString();
  }
}

export class TagFieldError implements ITagFieldError {
  name: string[] = [];

  constructor(data?: ITagFieldErrorData) {
    if (data) {
      this.name = data.name;
    }
  }

  clearErrors(): void {
    this.name.splice(0, this.name.length);
  }

  static isTagFieldError(data: ITagFieldErrorData): boolean {
    if (data.name && Array.isArray(data.name)) {
      return true;
    }
    return false;
  }
}
